import createVueApp from '@phoenix/createVueApp';
import GenericForm from '@maison/components/form/GenericForm.vue';

document.querySelectorAll('.phoenix-generic-form').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('GenericForm', GenericForm);
  app.mount(el);
});
